module.exports = __webpack_public_path__ + "img/brand-uipath.4fc3cec5.svg";